import React, { useEffect, useState } from "react";
import SectionWrapper from "../components/SectionWrapper";
import { VscDebugBreakpointLog } from "react-icons/vsc";
import { IoIosArrowDropleft, IoIosArrowDropright } from "react-icons/io";
const MembershipPage = () => {
  const [packages, setPackages] = useState([]);
  const [coreServices, setCoreServices] = useState([]);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [showForm, setShowForm] = useState(false);
  const [selectedPlan, setSelectedPlan] = useState(null);
  const [apiEndpoints, setApiEndpoints] = useState({});
  const [emailTemplate, setEmailTemplate] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState(null);
  
  const [formData, setFormData] = useState({
    clientName: "",
    email: "",
    contactNo: "",
  });

  // Load package data
  useEffect(() => {
    fetch("/AllJson/annualpackages.json", { cache: "force-cache" })
      .then((res) => res.json())
      .then((data) => setPackages(data.annualPackages))
      .catch((err) => console.error("Error loading packages:", err));
  }, []);
  //core Services
//core Services
useEffect(() => {
  fetch("/AllJson/coreservices.json", { cache: "force-cache" })
    .then((res) => res.json())
    .then((data) => {
      const original = data.CoreServices;
      setCoreServices([...original, ...original, ...original]); // 🔥 Circular infinite scroll
    })
    .catch((err) => console.error("Error loading Core Services:", err));
}, []);

  // Load API endpoints & email template
  useEffect(() => {
    fetch("/Template/email.txt")
      .then((res) => res.text())
      .then((data) => setEmailTemplate(data))
      .catch((err) => console.error("Error loading template:", err));

    fetch("/AllJson/apiendpoints.json")
      .then((res) => res.json())
      .then((data) => setApiEndpoints(data))
      .catch((err) => console.error("Error loading endpoints:", err));
  }, []);

  const openForm = (pkg) => {
    setSelectedPlan(pkg);
    setShowForm(true);
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    if (!emailTemplate) {
      alert("Email template not loaded yet!");
      setIsSubmitting(false);
      return;
    }

    try {
      let filledTemplate = emailTemplate;

      // Merge data for template
      const mergedData = {
        contactHeading: selectedPlan
          ? `Subscription Request - ${selectedPlan.name} Plan`
          : "General Enquiry",
        name: formData.clientName,
        email: formData.email,
        phone: formData.contactNo,
        type: selectedPlan ? selectedPlan.name : "General Enquiry",
        message: selectedPlan ? selectedPlan.price : "",
        preferredTimeSection: "", // ← MembershipPage में preferredTime नहीं है
      };

      Object.keys(mergedData).forEach((key) => {
        const regex = new RegExp(`{{${key}}}`, "g");
        filledTemplate = filledTemplate.replace(regex, mergedData[key] || "");
      });

      const payload = {
        fromMail: formData.email,
        emailSubject: `New Subscription - ${selectedPlan.name}`,
        emailBody: filledTemplate,
        entityName: "aegiscare",
      };

      const response = await fetch(apiEndpoints.enquiryUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          entity: "Aegis Care",
        },
        body: JSON.stringify(payload),
      });

      if (response.ok) {
        setSubmitStatus("success");
        console.log("📧 Final Email Body:\n", filledTemplate);
        alert(
          "Thank you! Your subscription request has been sent successfully."
        );
        setFormData({ clientName: "", email: "", contactNo: "" });
        setShowForm(false);
      } else {
        const errText = await response.text();
        console.error("API Error:", errText);
        setSubmitStatus("error");
        alert("Something went wrong. Please try again later.");
      }
    } catch (error) {
      console.error("Error submitting form:", error);
      setSubmitStatus("error");
    } finally {
      setIsSubmitting(false);
      setTimeout(() => setSubmitStatus(null), 5000);
    }
  };

  //core Services slider
  // Auto slide every 4 sec
  const getVisibleItems = () => {
    if (window.innerWidth < 640) return 1; // sm
    if (window.innerWidth < 1024) return 2; // md
    return 3; // lg
  };

  const [visibleItems, setVisibleItems] = useState(getVisibleItems());

  useEffect(() => {
    const handleResize = () => setVisibleItems(getVisibleItems());
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  const step = 1;
  // Infinite auto-loop slider (no reverse)
useEffect(() => {
  const interval = setInterval(() => {
    setCurrentIndex((prev) =>
      prev >= coreServices.length - visibleItems ? 0 : prev + 1
    );
  }, 3500);

  return () => clearInterval(interval);
}, [coreServices, visibleItems]);


  const totalItems = coreServices.length;
  const maxIndex = totalItems - visibleItems;
  // limit

 const nextSlide = () => {
  setCurrentIndex((prev) =>
    prev >= coreServices.length - visibleItems ? 0 : prev + 1
  );
};

const prevSlide = () => {
  setCurrentIndex((prev) =>
    prev === 0 ? coreServices.length - visibleItems : prev - 1
  );
};


  const totalSlides = Math.ceil(coreServices.length / 4);
  return (
    <div className="mt-14 mb-0">
      <SectionWrapper className="bg-gradient-to-r from-[#2c5779] to-[#18324a] text-white py-16">
        <div className="text-center m-16">
          <h2 className="text-3xl md:text-4xl font-bold mb-4">
            Yearly Plans
          </h2>
          <p className="text-xl opacity-90">
            Choose the perfect plan for your family's needs
          </p>
        </div>

        {/* Cards */}
        <div className="grid md:grid-cols-2 gap-6">
          {packages.map((pkg) => (
            <div
              key={pkg.name}
              className={`bg-white flex flex-col justify-between rounded-2xl p-8 shadow-2xl transform transition duration-300 hover:scale-95 hover:shadow-3xl ${
                pkg.name === "Premium" ? "border-4 border-yellow-400" : ""
              }`}
            >
              <div className="">
                <div className="text-center mb-6">
                  {pkg.name === "Premium" && (
                    <div className="bg-maroon text-white px-4 py-1 rounded-full text-sm font-bold mb-2">
                      Most Popular
                    </div>
                  )}
                  <h3 className="text-2xl font-bold text-[#2c5779] mb-2">
                    {pkg.name} Plan
                  </h3>
                  <div className="text-4xl font-bold text-gray-600 mb-4">
                    {pkg.price}
                    
                  </div>
                </div>

                {/* Features */}
                <ul className="space-y-3 mb-8 text-gray-700">
                  {Object.entries(pkg.features).map(([feature, value], i) => (
                    <li key={i} className="flex">
                      <div className="w-6 h-6 mr-2 text-[#2c5779]">
                        <VscDebugBreakpointLog />
                      </div>
                      <span>
                        {feature}:{" "}
                        <span className="font-bold">
                          {typeof value === "boolean"
                            ? value
                              ? "✅"
                              : "❌"
                            : value}
                        </span>
                      </span>
                    </li>
                  ))}
                </ul>
              </div>

              {/* Subscribe button */}
              <button
                onClick={() => openForm(pkg)}
                className="w-full justify-end align-bottom bg-[#2c5779] hover:bg-[#18324a] text-white py-3 rounded-full font-semibold transition-all duration-300"
              >
                Subscribe Now
              </button>
            </div>
          ))}
        </div>
        {/* core Services */}

        <div className="w-full py-8 lg:mx-auto ">
          <h1 className="text-3xl md:text-4xl py-4 text-white font-extrabold text-center tracking-wide">
            Exclusive Wellness Benefits
          </h1>

          <div className="flex items-center justify-between lg:gap-2 mt-6">
            {/* LEFT ARROW */}
            <button
              onClick={prevSlide}
              className="bg-white text-maroon lg:p-3 p-1 rounded-full shadow-lg hover:scale-110 transition"
            >
              <IoIosArrowDropleft className="lg:size-7 size-6" />
            </button>

            {/* SLIDER */}
            <div className="overflow-hidden w-full  lg:gap-1">
              <div
                className="flex transition-transform duration-700"
                style={{
                  width: `${totalItems * (100 / visibleItems)}%`,
                  transform: `translateX(-${
                    (100 / totalItems) * currentIndex
                  }%)`,
                }}
              >
                {coreServices.map((s, i) => (
                  <div key={i} className="lg:w-1/4 w-full mx-1">
                    <div className="bg-white flex flex-col p-4 w-full h-full shadow-md rounded-xl text-center border">
                      <div className="h-60 w-full flex items-center justify-center overflow-hidden object-contain mb-4">
                        <img
                          src={s.image}
                          alt={s.heading}
                          className="h-full w-full rounded-md object-cover"
                        />
                      </div>

                      <div>
                        <h1 className="font-semibold text-lg text-maroon">
                          {s.heading}
                        </h1>
                        <p className="text-gray-600 text-sm">{s.description}</p>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            {/* RIGHT ARROW */}
            <button
              onClick={nextSlide}
              className="bg-white text-maroon lg:p-3 p-1 rounded-full shadow-lg hover:scale-110 transition"
            >
              <IoIosArrowDropright className="lg:size-7 size-6" />
            </button>
          </div>
        </div>

        {/* Modal Form */}
        {showForm && selectedPlan && (
          <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
            <div className="bg-white rounded-2xl p-8 w-full max-w-md relative mx-2 shadow-lg animate-fadeIn">
              <button
                onClick={() => setShowForm(false)}
                className="absolute top-3 right-3 text-gray-500 hover:text-gray-800 text-xl font-bold"
              >
                &times;
              </button>
              <h3 className="text-2xl font-bold text-[#2c5779] mb-4 text-center">
                Subscribe to {selectedPlan.name} Plan
              </h3>
              <p className="text-center mb-6 text-gray-600">
                Price: {selectedPlan.price}/year
              </p>

              <form
                onSubmit={handleSubmit}
                className="space-y-4 mx-2 text-black"
              >
                <input
                  type="text"
                  name="clientName"
                  value={formData.clientName}
                  onChange={handleInputChange}
                  placeholder="Client Name"
                  required
                  className="w-full border border-gray-300 rounded-full px-4 py-2 focus:outline-none focus:ring-2 focus:ring-[#2c5779]"
                />
                <input
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={handleInputChange}
                  placeholder="Email"
                  required
                  className="w-full border border-gray-300 rounded-full px-4 py-2 focus:outline-none focus:ring-2 focus:ring-[#2c5779]"
                />
                <input
                  type="tel"
                  name="contactNo"
                  value={formData.contactNo}
                  onChange={handleInputChange}
                  placeholder="Contact No."
                  required
                  className="w-full border border-gray-300 rounded-full px-4 py-2 focus:outline-none focus:ring-2 focus:ring-[#2c5779]"
                />

                <button
                  type="submit"
                  disabled={isSubmitting}
                  className={`w-full bg-[#2c5779] text-white py-3 rounded-full font-semibold transition-all duration-300 ${
                    isSubmitting
                      ? "opacity-70 cursor-not-allowed"
                      : "hover:bg-[#18324a]"
                  }`}
                >
                  {isSubmitting ? "Submitting..." : "Submit"}
                </button>
              </form>
            </div>
          </div>
        )}
      </SectionWrapper>
    </div>
  );
};

export default MembershipPage;
